
export const managedContentConstants = {
  pageAlias: 'BprUIGems',
  helpTextAlias: 'Help_bprGemsPage',
  sharedTextAlias: 'Help_SharedText',
  gemsPageAliases : {
    messageCenter: 'messageCenter_GEMS',
    preferences: 'Preferences_GEMS'
  }, 
};

